module.exports = __webpack_public_path__ + "img/3.57ef8634.png";